var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isValid, format, cleanned } from "../../utils/cpf";
import { forgotPasswordSchema } from "../../schemas/forgotPasswordSchema";
import { useAuth } from "../../hooks/useAuth";
import Recaptcha from "../../components/modules/Recaptcha";
import { Card } from "../../components/modules/Card";
import { Form } from "../../components/elements/Form";
import { InputBase } from "../../components/elements/InputBase";
import { Button } from "../../components/elements/Button";
import { Text } from "../../components/elements/Text";
import { Container, Wrapper, ContentContainer, InfoContainer, FormContainer, } from "./styles";
export function ForgotPassword() {
    var _a = useAuth(), loading = _a.loading, erroHandler = _a.erroHandler, numberOfAttempts = _a.numberOfAttempts, onForgotPassword = _a.onForgotPassword;
    var handleBlurApplyMask = function (value) {
        var cleannedValue = cleanned(value);
        var result = value;
        if (cleannedValue.length === 11) {
            result = format(value);
        }
        return result;
    };
    function onSubmit(_a) {
        var login = _a.login;
        return __awaiter(this, void 0, void 0, function () {
            var username;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        username = login;
                        if (isValid(login)) {
                            username = cleanned(login);
                        }
                        return [4 /*yield*/, onForgotPassword(username)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    return (_jsx(Container, { children: _jsx(Wrapper, { children: _jsx(Card, { children: _jsxs(ContentContainer, { children: [_jsx(InfoContainer, { children: _jsxs(Text, __assign({ textStyle: "subtitle1", color: "fakeBlack" }, { children: ["Para continuar, digite ", _jsx("br", {}), "seu e-mail"] })) }), _jsx(Form, __assign({ schema: forgotPasswordSchema, onSubmit: onSubmit }, { children: function (_a) {
                                var _b, _c;
                                var control = _a.control, errors = _a.formState.errors, setValue = _a.setValue;
                                return (_jsxs(FormContainer, { children: [_jsx(InputBase, { name: "login", errorText: (_c = (_b = errors.login) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : erroHandler, placeholder: "Digite seu e-mail", disabled: loading, control: control, onBlur: function (event) {
                                                return setValue("login", handleBlurApplyMask(event.target.value));
                                            } }), _jsx(Button, { type: "submit", children: "Continuar", colorScheme: "gradient", buttonVariant: "h2", disabled: loading, loading: loading }), _jsx(Recaptcha, { numberOfAttempts: numberOfAttempts })] }));
                            } }))] }) }) }) }));
}
